import axios from "axios";
import { UserInfo } from "../store/main/actions";
import authRequest from "./utils/authRequest";

export const registerLogin = (data: {
  id_token: string;
  ref?: string | string[] | undefined;
  utmParams?: string;
}) => {
  return new Promise((resolve, reject) => {
    axios({
      url: `${process.env.NEXT_PUBLIC_API_URL}/user/register-login`,
      method: "post",
      data,
    })
      .then(({ data }) => {
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const verifyUser = (data: { oobCode: string }) => {
  return new Promise((resolve, reject) => {
    axios({
      url: `${process.env.NEXT_PUBLIC_API_URL}/user/verify`,
      method: "post",
      data,
    })
      .then(({ data }) => {
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const verifyResetPassword = (data: {
  oobCode: string;
  password: string;
}) => {
  return new Promise((resolve, reject) => {
    axios({
      url: `${process.env.NEXT_PUBLIC_API_URL}/user/ResetPassword`,
      method: "post",
      data,
    })
      .then(({ data }) => {
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const ResetPassword = (data: { email: string }) => {
  return new Promise((resolve, reject) => {
    axios({
      url: `${process.env.NEXT_PUBLIC_API_URL}/user/forgot-password`,
      method: "post",
      data,
    })
      .then(({ data }) => {
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      })
      .finally(() => {});
  });
};

const baseUrl = "/user";

export const getUser = () => {
  return new Promise<UserInfo>((resolve, reject) => {
    authRequest({
      url: `${baseUrl}/detail`,
      method: "get",
    })
      .then(({ data }) => {
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      })
      .finally(() => {});
  });
};

// not sure if we need a separate endpoint, already got content
export const getUserGenerations = (page: number, searchQuery: string) => {
  return new Promise((resolve, reject) => {
    authRequest({
      url: `${baseUrl}/dashboard`,
      method: "get",
      params: {
        page: page,
        size: 3,
        searchQuery: searchQuery,
      },
    })
      .then(({ data }) => {
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      })
      .finally(() => {});
  });
};

export const verifyUserToken = () => {
  return new Promise((resolve, reject) => {
    authRequest({
      url: `${baseUrl}/dashboard`,
      method: "get",
    })
      .then(({ data }) => {
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      })
      .finally(() => {});
  });
};

export const getCredits = () => {
  return new Promise((resolve, reject) => {
    authRequest({
      url: `${baseUrl}/sop-credits`,
      method: "get",
    })
      .then((response) => {
        if (response && response.data) resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      })
      .finally(() => {});
  });
};

export interface UserConfig {
  id?: string;
  language: string;
  language_level: string;
  english_type: string;
  plag_checker: string;
  expert_mode: boolean;
  full_name: string;
  country: string;
  course: string;
  ielts_score: string;
  highest_education: string;
}

export const getUserConfig = () => {
  return new Promise<UserConfig>((resolve, reject) => {
    authRequest({
      url: `${baseUrl}/user-config`,
      method: "get",
    })
      .then(({ data }) => {
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      })
      .finally(() => {});
  });
};

export const updateUserConfig = (data: UserConfig) => {
  return new Promise<UserInfo>((resolve, reject) => {
    authRequest({
      url: `${baseUrl}/user-config`,
      method: "post",
      data: data,
    })
      .then(({ data }) => {
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      })
      .finally(() => {});
  });
};
// export const getStream = (data: any) => {
//   return new Promise<any>((resolve, reject) => {
//     authRequest({
//       url: `chatbot/stream?question=${data}`,
//       method: "get",
//     })
//       .then(({ data }) => {

//         resolve(data);
//       })
//       .catch((err) => {
//         reject(err);
//       })
//       .finally(() => {});
//   });
// };
